import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  hangouts_enabled: true,
  demo_data_enabled: false,
};

const SystemFlagsContext = createContext({ flags: DEFAULTS, loading: true, refresh: () => {} });

export function SystemFlagsProvider({ children }) {
  const [flags, setFlags] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/system-flags/public");
      if (data && typeof data === "object") {
        setFlags({ ...DEFAULTS, ...data });
      }
    } catch {
      // Keep defaults if the endpoint is unreachable.
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SystemFlagsContext.Provider value={{ flags, loading, refresh }}>
      {children}
    </SystemFlagsContext.Provider>
  );
}

export const useSystemFlags = () => useContext(SystemFlagsContext);
